// src/AppWrapper.js (New File)
import React from 'react';
import { Outlet } from 'react-router-dom';
import { ChatProvider } from '../../Context/ChatContext';
import { ThemeProvider } from '../../Context/ThemeContext';
import { RoleProvider } from '../../Context/RoleContext';

const AppWrapper = () => {
  return (
    <ThemeProvider>
      <RoleProvider>
        <ChatProvider>
          <Outlet /> {/* Nested routes will render here */}
        </ChatProvider>
      </RoleProvider>
    </ThemeProvider>
  );
};

export default AppWrapper;